export default __webpack_public_path__ + "static/media/Dorothy and Grace.3c8a1ec9.jpg";